var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCorrect = function SvgCorrect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .671 2.234 5.437 0 3.203l.671-.672 1.563 1.564L6.33 0 7 .671Z",
    fill: "#01B248"
  })));
};
export { SvgCorrect as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNyA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNyAwLjY3MTQ1OEwyLjIzNDI5IDUuNDM2ODVMMCAzLjIwMjg3TDAuNjcxNDU4IDIuNTMxNDJMMi4yMzQyOSA0LjA5NDU3TDYuMzI4NTQgMEw3IDAuNjcxNDU4WiIgZmlsbD0iIzAxQjI0OCIvPgo8L3N2Zz4K";